var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58",
    "data-name": "Mask Group 58",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(253.714 9.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M3.857,10.286c1.911,0,2.721-1.447,3.436-2.724.726-1.3,1.353-2.419,2.993-2.419s2.267,1.121,2.993,2.419c.715,1.277,1.525,2.724,3.436,2.724h2.571V9H16.714c-1.1,0-1.6-.784-2.314-2.066-.766-1.371-1.72-3.077-4.114-3.077S6.938,5.563,6.171,6.934C5.453,8.215,4.958,9,3.857,9H2.571V1.286H1.286V18a1.286,1.286,0,0,0,1.286,1.286H19.286V18H18V14.143H16.714V18H14.143V12.857H12.857V18H10.286V10.286H9V18H6.429V12.857H5.143V18H2.571V10.286Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.e5340f33a4dc263e15472650c0564474.svg";
export { ForwardRef as ReactComponent };